import './index.css';
import 'react-toastify/dist/ReactToastify.css';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ToastContainer } from 'react-toastify';

import App from './App';
import AlertModal from './components/AlertModal';
import BlockedIpModal from './components/BlockedIpModal';
import DialogModal from './components/DialogModal';
import MaintenanceGate from './components/MaintenanceGate';
import * as serviceWorker from './serviceWorker';

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

const root = document.getElementById('root');
// Keep GoogleReCaptchaProvider outside Suspense/MaintenanceGate. Remounting it
// (e.g. i18n suspense in a fresh private session) races Google's script cleanup
// and throws "Missing required parameters: sitekey", blanking the app.
ReactDOM.createRoot(root).render(
  <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
    <Suspense>
      <React.Fragment>
        <MaintenanceGate>
          <App />
        </MaintenanceGate>
        <AlertModal />
        <BlockedIpModal />
        <DialogModal />
        <ToastContainer
          position='bottom-right'
          autoClose={3000}
          closeOnClick={false}
        />
      </React.Fragment>
    </Suspense>
  </GoogleReCaptchaProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
